import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class CicloDistribuicaoDto extends BaseEntity {
  public numero!: number;
  public numeroTranche!: number;
  public dataInicio!: Date;
  public dataFim!: Date | null;
  public valorAporte!: number;
  public dataCriacao!: Date;
  public valorPercentualMinimoMeta1PrimeiraDistribuicao!: number;
  public valorPercentualMinimoMeta2PrimeiraDistribuicao!: number;
  public valorPercentualMinimoMeta3PrimeiraDistribuicao!: number;
  public valorPercentualMinimoMeta4PrimeiraDistribuicao!: number | null;
  public valorPercentualMinimoMetaSegundaDistribuicao!: number;
  public valorPercentualMinimoMetaTerceiraDistribuicao!: number;
  public valorPercentualReducaoNaoCumprimentoMeta2PrimeiraDistribuicao!: number;
  public valorTotalRenunciaAgentesNoCiclo!: number | null;
  public valorRenunciaDirecionadaAgentesNoCiclo!: number | null;
  public valorRenunciaParaDistribuicaoTodosAgentesNoCiclo!: number | null;
  public valorTotalRenunciaSerDistribuidoNoPeriodo!: number | null;
  public ignoraMetas!: boolean;
}

